import { useState } from 'react';
import { useT } from '@hana/i18n';
import { PageHeader } from '@hana/shell';
import { Modal, StateView, useToast, type ScreenState } from '@hana/ui';
import { LOOKUPS, NEWS0, SOP, isRead, refreshedAt, unreadCount, type LookupId } from './newsData';
import './news.i18n';
import s from './news.module.css';

const STATES: ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];
function forcedState(): ScreenState {
  const v = new URLSearchParams(location.search).get('state');
  return STATES.includes(v as ScreenState) ? (v as ScreenState) : 'ready';
}

/** Mint-Mov-Phone3 khung 1 "Bảng tin & cài app" (giả lập, giữ trong bộ nhớ, toast có Hoàn tác). */
export function News() {
  const state = forcedState();
  const t = useT();
  const toast = useToast();
  const [push, setPush] = useState(false);
  const [installed, setInstalled] = useState(false);
  const [read, setRead] = useState<Record<string, boolean>>({});
  const [fresh, setFresh] = useState(false);
  const [sop, setSop] = useState(false);
  const n = unreadCount(NEWS0, read);

  const lookup = (id: LookupId) => {
    if (id === 'sop1' || id === 'sop2') setSop(true);
    else if (id === 'route') toast({ msg: t('mvn.map') });
    else toast({ msg: t('mvn.video') });
  };
  const row = (k: string, v: string, act?: { label: string; on: () => void }, opt?: { dot?: boolean; read?: boolean }) => (
    <div key={k} className={s.row}>
      {opt?.dot && <span className={s.dot} aria-hidden="true" />}
      <div><div className={s.k} data-read={opt?.read ? '1' : '0'}>{k}</div><div className={s.v}>{v}</div></div>
      {act && <button type="button" className={s.act} onClick={act.on}>{act.label}</button>}
    </div>
  );

  return (
    <>
      <PageHeader title={t('mvn.title')} />
      <div className={s.page}>
        {state === 'error' && <div role="status" className={s.net}><b>{t('mvn.netB')}</b>{t('mvn.netT')}</div>}
        {state === 'noperm' && <div role="status" className={s.net}><b>{t('mvn.nopB')}</b>{t('mvn.nopT')}</div>}
        <StateView
          state={state === 'error' || state === 'noperm' || state === 'empty' ? 'ready' : state}
          skeleton={<>{[0, 1, 2, 3].map((i) => <div key={i} className={s.sk} aria-hidden="true" />)}</>}
        >
          {!push && (
            <section className={s.card} aria-label={t('mvn.push')}>
              <div className={s.hd}><b>{t('mvn.push')}</b><span data-t="warn">{t('mvn.off')}</span></div>
              {row(t('mvn.pushK'), t('mvn.pushV'))}
              <button type="button" className={s.btn} onClick={() => { setPush(true); toast({ msg: t('mvn.pushOn'), undo: () => setPush(false) }); }}>{t('mvn.pushBtn')}</button>
            </section>
          )}
          {!installed && (
            <section className={s.card} aria-label={t('mvn.install')}>
              <b className={s.hd}>{t('mvn.install')}</b>
              {row(t('mvn.addK'), t('mvn.addV'))}
              <button type="button" className={s.soft} onClick={() => { setInstalled(true); toast({ msg: t('mvn.added'), undo: () => setInstalled(false) }); }}>{t('mvn.addK')}</button>
            </section>
          )}
          <section className={s.card} aria-label={t('mvn.feed')}>
            <div className={s.hd}><b>{t('mvn.feed')}</b><span>{t('mvn.unread', { n })}</span></div>
            {NEWS0.map((it) => {
              const r = isRead(it, read);
              return row(it.title, it.meta + (r ? t('mvn.readTag') : ''), r ? undefined : { label: t('mvn.markRead'), on: () => setRead((m) => ({ ...m, [it.id]: true })) }, { dot: !r, read: r });
            })}
          </section>
          <section className={s.card} aria-label={t('mvn.lookup')}>
            <b className={s.hd}>{t('mvn.lookup')}</b>
            {LOOKUPS.map((l) => row(l.title, l.sub, { label: l.act, on: () => lookup(l.id) }))}
          </section>
          <section className={s.card} aria-label={t('mvn.refresh')}>
            <b className={s.hd}>{t('mvn.refresh')}</b>
            {row(t('mvn.pull'), t('mvn.at', { t: refreshedAt(fresh) }), { label: t('mvn.refresh'), on: () => { setFresh(true); toast({ msg: t('mvn.refreshed') }); } })}
          </section>
        </StateView>
      </div>

      <Modal
        open={sop}
        onOpenChange={setSop}
        title={SOP.title}
        footer={<button type="button" className={s.btn} style={{ width: '100%' }} onClick={() => setSop(false)}>{t('mvn.ok')}</button>}
      >
        <p className={s.hint}>{SOP.desc}</p>
        <ol className={s.doc}>{SOP.steps.map((x) => <li key={x}>{x}</li>)}</ol>
      </Modal>
    </>
  );
}
